module.exports = __webpack_public_path__ + "img/characterIllustration.7ab63049.png";